import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../Atoms/Icon';
import PackageFilterContainer from './modules/PackageFilterContainer';

function Inclusion({ inclusions, selectedInclusions, labelText, onToggle }) {
  if (!inclusions || inclusions.length === 0) return null;

  return (
    <PackageFilterContainer>
      <form className="PackageFilter PackageFilter_packageOptionsContainer">
        <div className="PackageFilter_fieldset PackageFilter_packageOptions">
          <div className="PackageFilter_packageOptionsTitle">{labelText}:</div>
          <div className="PackageFilter_packageOptionsButtons">
            {inclusions.map((inclusion) => (
              <button
                key={inclusion.id}
                type="button"
                className={`Button ${
                  selectedInclusions?.includes(inclusion.id) ? 'Button-fill selected' : 'Button-alt'
                }`}
                onClick={() => onToggle(inclusion.id)}
              >
                <Icon id={inclusion.id} blockName="PackageFilter_icon" />
                <span>{inclusion.title}</span>
              </button>
            ))}
          </div>
          <div className="PackageFilter_flexFill" />
        </div>
      </form>
    </PackageFilterContainer>
  );
}

Inclusion.propTypes = {
  inclusions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedInclusions: PropTypes.arrayOf(PropTypes.string),
  labelText: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
};

Inclusion.defaultProps = {
  selectedInclusions: [],
};

export default Inclusion;
